import React from 'react';

import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {SubTitleSmall} from '@spaced-out/ui-design-system/lib/components/Text';
import {ComponentTypeItem} from 'src/components/automation/common/survey-addon';

import css from './scheduler-addon.css';


interface IProps {
  onSelect: (id: string) => void;
}

export const ComponentSelector = ({onSelect}: IProps) => {
  const {t} = useLabelTranslation();
  return (
    <div className={css.content}>
      <SubTitleSmall>
        {t(
          'Select_the_component_to_open_Meeting_Template_link',
          'Select the component to open Meeting Template link',
        )}
      </SubTitleSmall>
      <ComponentTypeItem
        iconName="rectangle-wide"
        id="button"
        onSelect={onSelect}
        title={t('Button', 'Button')}
        description={t(
          'Template_list_will_be_opened_in_new_tab_when_button_is_clicked',
          'Template list will be opened in new tab when button is clicked',
        )}
      />
      <ComponentTypeItem
        iconName="text"
        id="text"
        onSelect={onSelect}
        title={t('Text_Component', 'Text Component')}
        description={t(
          'Template_list_will_be_opened_in_new_tab_when_hyper_link_is_clicked',
          'Template list will be opened in new tab when hyper link is clicked',
        )}
      />
    </div>
  );
};
